import { AddShoppingCartOutlined } from "@mui/icons-material";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Rating,
  Typography,
} from "@mui/material";
import React from "react";
import "./ProductCard.css";

const ProductCard = ({ product, handleAddToCart }) => {
  return (
    <Card className="card">
      
      <CardMedia
          component="img"
          image={product.image}
          alt={product.name}
        />
      
      <CardContent>
      <Typography variant="h6" component="legend">
        {product.name}
      </Typography>
      <Typography variant="h6" component="legend">
        {'$'}{product.cost}
      </Typography >
      <Rating name="read-only" value={product.rating} readOnly />
      </CardContent>
      <CardActions className="card-actions">
      <Button variant="contained" className="card-button" onClick={(e)=>{handleAddToCart(product._id)}} fullWidth><AddShoppingCartOutlined />ADD TO CART</Button>
      </CardActions> 
    </Card>
  );
};

export default ProductCard;
